export interface UserRole {
  name: string;         // displayName from the group entity (e.g. "Platform Leads")
  groupRef: string;     // full entity ref (e.g. "group:default/platform-lead")
  groupName: string;    // short group name (e.g. "platform-lead")
  color: string;
}

export interface UserIdentity {
  displayName: string;
  email: string;
  initials: string;
  roles: UserRole[];
  elevatedRole: UserRole;
}

export type EntityKind = 'component' | 'template' | 'api' | 'group' | 'user' | 'docs';

export interface SearchResultItem {
  kind: EntityKind;
  name: string;
  description: string;
  namespace: string;
  link: string;
}

/** Groups whose active selection grants admin-level access */
export const ADMIN_GROUPS: string[] = [
  'platform-lead',
  'demo-admins',
];

/** Groups whose active selection grants developer-level access */
export const DEVELOPER_GROUPS: string[] = [
  'platform-engineering',
  'app-modernization',
  'cloud-native',
  'data-and-ai',
];

/** Colour palette for role chips — keyed by group name */
export const GROUP_COLORS: Record<string, string> = {
  'platform-lead': '#7f77dd',
  'platform-engineering': '#1d9e75',
  'demo-admins': '#3b82f6',
  'demo-users': '#d85a30',
  'app-modernization': '#d97706',
  'cloud-native': '#0ea5e9',
  'data-and-ai': '#8b5cf6',
};

const DEFAULT_COLOR = '#6b7280';

export function groupColor(groupName: string): string {
  return GROUP_COLORS[groupName] || DEFAULT_COLOR;
}

/**
 * Priority order for selecting the default elevated role.
 * Lower index = higher priority. Groups not listed get lowest priority.
 */
export const GROUP_PRIORITY: string[] = [
  'platform-lead',
  'platform-engineering',
  'demo-admins',
  'app-modernization',
  'cloud-native',
  'data-and-ai',
  'demo-users',
];
